import { CUSTOM_ELEMENTS_SCHEMA, NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Routes, RouterModule } from '@angular/router';
import { ROUTES } from './app.routes';
import { WebsocketService } from '@services/websocket.service';
// toast.
import { ToastContainerModule, ToastNoAnimationModule, ToastrModule } from 'ngx-toastr';
// translate.
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
// toast.
import { ToastService } from '@services/toast.service';
// local storage.
import { NgxWebstorageModule } from 'ngx-webstorage';
// Modulos de los componentes.
import { QSignerModule } from '@views/qSigner/qSigner.module';
import { QWebPrinterModule } from '@views/qWebPrinter/qWebPrinter.module';
import { QSignerHomeModule } from '@views/qSignerHome/qSignerhome.module';
import { PdfViewerModule } from 'ng2-pdf-viewer';

// Traduciones.
import localeES from '@angular/common/locales/es';
import localeCL from '@angular/common/locales/es-CL';
import localePE from '@angular/common/locales/es-PE';
registerLocaleData(localeES);
registerLocaleData(localeCL);
registerLocaleData(localePE);

// required for AOT compilation.
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    // Rutas.
    RouterModule.forRoot(ROUTES, { useHash: true }),
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    AppRoutingModule,
    FormsModule,
    // Toast.
    ToastrModule.forRoot(),
    ToastContainerModule,
    ToastNoAnimationModule,
    // Almacenamiento local.
    NgxWebstorageModule.forRoot(),
    // Traducciones.
    HttpClientModule,
    TranslateModule.forRoot({
      useDefaultLang: true,
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    // Modulos de componentes.
    QWebPrinterModule,
    QSignerHomeModule,
    QSignerModule,
    PdfViewerModule,
  ],
  providers: [ToastService, QWebPrinterModule, QSignerHomeModule, QSignerModule, WebsocketService, { provide: LOCALE_ID, useValue: 'es-ES' }],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
